// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"1f210234","391":"ca5cdcdd","611":"82393eb5","831":"ff130e72","959":"014d330f"}[chunkId] + ".chunk.js";
};